import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=534c6e24&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=ts"
export * from "./GroupForm.vue?vue&type=script&lang=ts"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=534c6e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534c6e24",
  null
  
)

export default component.exports